export class KafkaSecretProbeResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "saslSecret",
            "baseName": "saslSecret",
            "type": "SaslSecretProbe",
            "format": ""
        },
        {
            "name": "tlsSecret",
            "baseName": "tlsSecret",
            "type": "TlsSecretProbe",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return KafkaSecretProbeResponse.attributeTypeMap;
    }
    constructor() {
    }
}
